var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Alert } from '@one-thd/sui-atomic-components';
import { CustomerAccountNavigation } from '@thd-olt-component-react/customer-account-navigation';
import { PageTitle } from './page-title';
import { ERR_GENERIC } from '../../../constants';
import { useIsMobile } from '../../../hooks';
import { ACCOUNT_BREADCRUMBS_BASE } from '../../../constants/general';
import { useInterceptors } from '../../../hooks/use-interceptors';
import commonStyles from '../../../styles/common.module.scss';
export var PageGrid = function (props) {
    var children = props.children;
    var isMobile = useIsMobile().isMobile;
    var containerClass = "pdContainer__".concat(isMobile ? 'mobile' : 'desktop');
    return (React.createElement("div", { "data-id": "PageGrid", className: "sui-my-0 sui-mx-auto sui-max-w-[1440px] ".concat(containerClass) },
        React.createElement("div", { className: "sui-px-4 sui-py-6 sm:sui-px-6" }, children)));
};
export var PageContainer = function (props) {
    var children = props.children, classes = props.classes, breadcrumbs = props.breadcrumbs, title = props.title, generalError = props.generalError, _a = props.suppressNavHeading, suppressNavHeading = _a === void 0 ? false : _a;
    var isConsumerApp = useIsMobile().isConsumerApp;
    var enableWholePageOnError = true;
    var NavHeading = function () {
        return (React.createElement("div", { "data-id": "NavHeading", className: "sui-gap-[10px] sui-grid sui-grid-cols-1 sui-pb-4 sm:sui-pb-[10px]" },
            !isConsumerApp && (React.createElement(QueryProvider, { cacheKey: "customer-loyalty" },
                React.createElement(Breadcrumbs, { staticCrumbs: __spreadArray(__spreadArray([], ACCOUNT_BREADCRUMBS_BASE, true), breadcrumbs, true) }))),
            React.createElement(PageTitle, { title: title })));
    };
    return (React.createElement(React.Fragment, null,
        !suppressNavHeading && React.createElement(NavHeading, null),
        React.createElement("div", { "data-id": "PageContainer", className: "sui-mt-[10px] sui-grid sui-grid-cols-1 lg:sui-grid-cols-4 lg:sui-mr-6 sui-gap-8" },
            React.createElement("div", null,
                React.createElement(QueryProvider, { cacheKey: "left-nav" },
                    React.createElement(CustomerAccountNavigation, null))),
            React.createElement("div", { className: "lg:sui-col-span-3 ".concat(classes === null || classes === void 0 ? void 0 : classes.contentContainer) }, generalError && !enableWholePageOnError ? (React.createElement(Alert, { status: "error" }, (generalError === null || generalError === void 0 ? void 0 : generalError.message)
                ? generalError.message
                : ERR_GENERIC.message)) : (React.createElement(React.Fragment, null,
                React.createElement("div", null, generalError && (React.createElement(Alert, { status: "error" }, (generalError === null || generalError === void 0 ? void 0 : generalError.message)
                    ? generalError.message
                    : ERR_GENERIC.message))),
                children))))));
};
export var PageErrorRedirector = function (props) {
    var children = props.children;
    var redirectError = useInterceptors().redirectError;
    var RenderRedirectError = function () { return (React.createElement("div", { "data-id": "RenderRedirectError", className: commonStyles.redirectMsgWrap },
        React.createElement(Alert, { status: "info" }, redirectError === null || redirectError === void 0 ? void 0 : redirectError.message))); };
    return redirectError ? React.createElement(RenderRedirectError, null) : React.createElement(React.Fragment, null, children);
};
